import $ from "jquery";
//import { uuid } from "vue-uuid";

export const ajaxDeleteHelper = function (deleteUrl, callback) {
  $.ajax({
    method: "DELETE",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: deleteUrl,
    success: (result) => {
      callback(result);
    },
  });
};

export const ajaxGetAndReturn = function (url,callback){
  $.ajax({
    method: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: url,
    xhrFields: {
      withCredentials: false,
    },
    success: (result) => {
      //console.log(result);
      callback(result);
    },
  });
}

export const ajaxGeneralHelper = function (actionUrl, ajaxMethod, dataObj, callback) {
  $.ajax({
    method: ajaxMethod,
    data: JSON.stringify(dataObj),
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: actionUrl,
    xhrFields: {
      withCredentials: false,
    },
    success: (result) => {
      //console.log(result);
      if(callback)
        callback(result);
    },
  });
};
